import { ApiResult } from 'common/models/api-service/api-result.model';
import { GraphClient } from 'common/services/graph-client.service';
import { HttpClient } from 'common/services/http-client.service';
import userConfig from './user.config';

export class UserService extends HttpClient {
    public static async getUserProfile(): Promise<ApiResult<any>> {
        return await GraphClient.getCurrentUserProfile();
    }

    public static async getUserImage(): Promise<ApiResult<Blob>> {
        return await GraphClient.getCurrentUserAvatar();
    }

    public static async getUserInfo() {
        return UserService.invokeApi(userConfig.getUserInfoUrl());
    }
}
